import React, { useEffect, useState } from "react";

export default function DocPost({ path }) {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    const fetchDoc = async () => {
      const r = await fetch(`/${path}/`, { cache: "no-store" });
      const raw = await r.text();

      const doc = new DOMParser().parseFromString(raw, "text/html");

      const post = doc.body;

      setHtml(post?.innerHTML ?? "");
    };

    fetchDoc();
  }, [path]);

  return (
    <div>
      <div>
        {html === null && <p>Loading…</p>}

        {html !== null && html !== "" && (
          <article className="html-doc">
            <div>
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </article>
        )}

        {html === "" && (
          <div>
            Couldn’t load content for <code>{path}</code>. Make sure Jekyll has written it under{" "}
            <code>{path}</code>.
          </div>
        )}
      </div>
    </div>
  );
}
